<template>
  <el-link
    :class="`${bem.b()} ${prepareClassNames()}`"
    :style="{
      ...prepareStyles(),
    }"
    v-bind="{
      ...props,
      ...attrs,
    }"
  >
    <template v-if="content">
      {{ content }}
    </template>
    <template v-for="name in slots" #[name]="scope">
      <slot :name="name" v-bind="scope"> </slot>
    </template>
  </el-link>
</template>
<script setup lang="ts">
import { computed, useSlots, useAttrs } from 'vue'
import { createNameSpace } from '@el-plus/utils/bem'
import { linkProps } from './link'
import { prepareClassNames, prepareStyles } from '@el-plus/utils/props'
defineOptions({
  name: 'EpLink',
  inheritAttrs: false,
})
const bem = createNameSpace('link')
const props = defineProps(linkProps)
const attrs = useAttrs()
const slots = computed(() => {
  return Object.keys(useSlots())
})
</script>
